var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*
* Created on Mon Nov 19 2018
*
* Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CovetcbaRequest, RestorePasswordRequest, ResetPasswordRequest } from '../_models';
import { sha256 } from 'js-sha256';
import { environment } from '../../environments/environment';
import jwt_decode from 'jwt-decode';
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(http) {
        this.http = http;
        this.idmenuweb = 0;
        this.comunicacion = false;
        var currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser != undefined) {
            var kermetPayload = jwt_decode(currentUser.token)['kermetPayload'];
            this.idmenuweb = kermetPayload['idmenuweb'];
            // this.comunicacion = kermetPayload['flag_comunicacion'];
        }
    }
    AuthenticationService.prototype.login = function (username, password) {
        var _this = this;
        var request = new CovetcbaRequest();
        var h1 = sha256(username.toLocaleLowerCase() + ' ' + password);
        request.usuario = username.toLocaleLowerCase();
        request.nonce = Date.parse("2099/05/28 00:00:00");
        // request.nonce = Math.ceil(Date.now());
        request.hash = sha256(request.nonce + ' ' + h1);
        console.log(request.hash);
        return this.http.post(environment.apiUrl + '/jwt/login', request)
            .pipe(map(function (user) {
            // login successful if there's a jwt token in the response
            if (user && user.token) {
                console.log(user);
                sessionStorage.setItem('currentUser', JSON.stringify(user));
                var kermetPayload = jwt_decode(user.token)['kermetPayload'];
                _this.idmenuweb = kermetPayload['idmenuweb'];
                // TODO: Uncomment this when comunicaciones has been implemented.
                // this.comunicacion = kermetPayload['comunicaciones'];
            }
            return user;
        }));
    };
    AuthenticationService.prototype.restore = function (email) {
        var request = new RestorePasswordRequest();
        request.email = email;
        return this.http.post(environment.apiUrl + '/jwt/restore', request);
    };
    AuthenticationService.prototype.reset = function (username, password, resetid) {
        var request = new ResetPasswordRequest();
        request.resetid = resetid;
        request.usuario = username.toLocaleLowerCase();
        request.nonce = Date.parse("2099/05/28 00:00:00");
        request.hash = sha256(username.toLocaleLowerCase() + ' ' + password);
        ;
        return this.http.post(environment.apiUrl + '/jwt/restore', request);
    };
    AuthenticationService.prototype.logout = function () {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('matriculado');
    };
    AuthenticationService.prototype.isDistrubuidora = function () {
        return this.idmenuweb == 1;
    };
    AuthenticationService.prototype.isMatriculado = function () {
        return this.idmenuweb == 0;
    };
    AuthenticationService.prototype.showComunicacion = function () {
        return this.comunicacion;
    };
    AuthenticationService.prototype.setComunication = function (val) {
        this.comunicacion = val;
    };
    AuthenticationService.prototype.get_user = function () {
        var currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser != undefined) {
            var kermetPayload = jwt_decode(currentUser.token)['kermetPayload'];
            return kermetPayload['usuario'];
        }
        return null;
    };
    AuthenticationService = __decorate([
        Injectable({ providedIn: 'root' }),
        __metadata("design:paramtypes", [HttpClient])
    ], AuthenticationService);
    return AuthenticationService;
}());
export { AuthenticationService };
//# sourceMappingURL=authentication.service.js.map